var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet } from 'react-native';
import { TouchableWithoutFeedback } from "../../../../devsupport";
import { styled } from "../../../../theme";
export let CalendarPickerCell = (_dec = styled('CalendarCell'), _dec(_class = (_temp = class CalendarPickerCell extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onPress", () => {
      this.props.onSelect && this.props.onSelect(this.props.date);
    });

    _defineProperty(this, "getContainerBorderRadius", borderRadius => {
      const {
        firstRangeItem,
        lastRangeItem
      } = this.props;

      if (firstRangeItem) {
        return {
          borderBottomLeftRadius: borderRadius,
          borderBottomRightRadius: 0,
          borderTopLeftRadius: borderRadius,
          borderTopRightRadius: 0
        };
      }

      if (lastRangeItem) {
        return {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: borderRadius,
          borderTopLeftRadius: 0,
          borderTopRightRadius: borderRadius
        };
      }

      return {};
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        contentBorderWidth,
        contentBorderRadius,
        contentBorderColor,
        contentBackgroundColor,
        contentTextFontSize,
        contentTextFontWeight,
        contentTextColor,
        contentTextFontFamily,
        borderRadius
      } = source,
            containerParameters = _objectWithoutProperties(source, ["contentBorderWidth", "contentBorderRadius", "contentBorderColor", "contentBackgroundColor", "contentTextFontSize", "contentTextFontWeight", "contentTextColor", "contentTextFontFamily", "borderRadius"]);

      return {
        container: _objectSpread(_objectSpread({}, containerParameters), this.getContainerBorderRadius(borderRadius)),
        contentContainer: {
          borderWidth: contentBorderWidth,
          borderRadius: contentBorderRadius,
          borderColor: contentBorderColor,
          backgroundColor: contentBackgroundColor
        },
        contentText: {
          fontSize: contentTextFontSize,
          fontWeight: contentTextFontWeight,
          color: contentTextColor,
          fontFamily: contentTextFontFamily
        }
      };
    });

    _defineProperty(this, "renderContentElement", (source, evaStyle) => {
      return source && source(this.props.date, {
        container: evaStyle.contentContainer,
        text: evaStyle.contentText
      });
    });
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.shouldComponentUpdate) {
      return nextProps.shouldComponentUpdate(this.props, nextProps);
    }

    return true;
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      date,
      bounding,
      children
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "date", "bounding", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, _extends({}, touchableProps, {
      style: [evaStyle.container, styles.container, style],
      onPress: this.onPress
    }), this.renderContentElement(children, evaStyle));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flex: 1
  }
});